import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import ItemsTable from '../../AppGrid/ItemsTable';
import strings from '../../Globalization';

const Items = () => {
	const [activeRecord, setActiveRecord] = useState(null);
	const handleOnOpenForm = ({ record }) => {
		setActiveRecord(record);
	};


	return (
		<Box>
			<ItemsTable onOpenForm={handleOnOpenForm} />
			<Dialog
				fullWidth
				maxWidth="md"
				open={!!activeRecord}
				sx={{
					'& .MuiDialogContentText-root': {
						border: (theme) => `1px solid ${theme.palette.divider}`,
						borderRadius: (theme) => theme.spacing(0.5),
						backgroundColor: 'action.selected',
						padding: (theme) => theme.spacing(2),
						zIndex: (theme) => theme.zIndex.tooltip
					}
				}}
				disableEscapeKeyDown
			>
				<DialogTitle sx={{ display: 'flex', flexDirection: 'row' }}>
					<Typography variant="h5" component="div" color="primary" sx={{ flex: 1 }}>
						{strings.ItemCodes}
					</Typography>
					<Button
						onClick={() => setActiveRecord(null)}
						title={strings.Close}
						color="error"
						variant="contained"
						size="small"
						sx={{
							px: 1,
							fontSize: 14,
							textTransform: 'uppercase',
							fontWeight: 'bold',
						}}
					>
						{strings.Close}
					</Button>

				</DialogTitle>
				<Divider />
				<DialogContent>
					{!!activeRecord?.ItemCodes && (
						<DialogContentText component="div">
							<pre>{activeRecord?.ItemCodes}</pre>
						</DialogContentText>
					)}
				</DialogContent>
			</Dialog>
		</Box>
	);
}

export default Items;